import fetch from 'isomorphic-fetch';
import { checkHttpStatus, parseJSON } from '../utils';
import ExploreAuth from '../utils/ExploreAuth';

const disqusErrors = {
  1: 'Endpoint not valid',
  2: 'Missing or invalid argument',
  3: 'Endpoint resource not valid',
  4: 'You must be authenticated to perform this action',
  5: 'Invalid API key',
  6: 'Invalid API version',
  7: 'You cannot access this resource using %(request_method)s',
  8: 'A requested object was not found',
  9: 'You cannot access this resource using your %(access_type)s API key',
  10: 'This operation is not supported',
  11: 'Your API key is not valid on this domain',
  12: 'This application does not have enough privileges to access this resource',
  13: 'You have exceeded the rate limit for this resource',
  14: 'You have exceeded the rate limit for your account',
  15: 'There was internal server error while processing your request',
  16: 'Your request timed out',
  17: 'The authenticated user does not have access to this feature',
  18: 'The authorization signature you passed was not valid',
  19: 'You must re-submit this request with a response to the captcha challenge',
  20: 'The API is currently undergoing maintenance, and your changes were saved, but will not be visible yet.',
  21: 'The API is currently undergoing maintenance, and your changes could not be saved.',
  22: 'You do not have the appropriate permissions to access this resource',
  23: 'You must be authenticated and verified by the forum owner to perform this action',
  24: 'You have exceeded the maximum number of creations for this resource',
  25: 'An error occurred with a third party service',
};

export function postComment(
  commentBody,
  disqusId,
  remoteAuth,
  snapshotUrl,
  livecamId,
  newCommentSystem,
  pageUrl,
  successCallback,
  failureCallback,
) {
  return ExploreAuth.getValidJwt()
    .then((tokenIsValid) => {
      // Token can't be refreshed log them out
      if (!tokenIsValid) {
        // We should probably add a modal here informing them they need to log back in.
        // TODO handle invalid token error.
      }
      return fetch(`${SERVER_URL}/submit_comment`, {
        method: 'post',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${ExploreAuth.getJwt()}`,
        },
        body: JSON.stringify({ comment: commentBody, disqus_id: disqusId, snapshotUrl, livecamId, newCommentSystem, pageUrl }),
      })
        .then(checkHttpStatus)
        .then(parseJSON)
        .then((responseData) => {
          if (responseData?.data?.trd) {
            const { trd: thread, sso: remote_auth, com: message } = responseData.data;
            fetch(`${SERVER_URL}/submit_disqus_comment`, {
              method: 'post',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${ExploreAuth.getJwt()}`,
              },
              body: JSON.stringify({ thread, remote_auth, message }),
            })
              .then(checkHttpStatus)
              .then(parseJSON)
              .then((res) => {
                console.log('Disqus Response:');
                console.log(res);
                successCallback(res);
              });
          } else {
            successCallback(responseData);
          }
        })
        .catch((error) => {
          failureCallback(error);
          console.log(error);
        });
    });
}
